import { v } from "convex/values";
import { defineTable } from "convex/server";
import { internalControl } from "../../../lib/shared/validators";

export const statusInvoicesExemptions = v.union(
  v.literal("pending"),
  v.literal("approved"),
  v.literal("rejected"),
  v.literal("expired"),
  v.literal("cancelled"),
);

export const invoiceExemptionValidator = v.object({
  status: statusInvoicesExemptions,
  invoiceId: v.id("invoices"),
  clientId: v.id("clients"),
  exemptDocuments: v.array(v.id("clients_exempt_documents")),
  appliedAt: v.number(),
  internalControl,
});

export const invoices_exemptions = defineTable(invoiceExemptionValidator)
  .index("by_client", ["clientId"])
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_client_company", ["clientId", "internalControl.companyId"])
  .index("by_company_and_status", ["internalControl.companyId", "status"])
  .index("by_branch_id", ["internalControl.branchId"])
  .index("by_invoice", ["invoiceId"])
  .index("by_documents", ["exemptDocuments"])
  .index("by_status", ["status"])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ]);
